document.addEventListener('DOMContentLoaded', () => {
  const main = document.querySelector('#MainContent[data-policy-handle]');
  const body = main?.querySelector('.shopify-policy__body .rte');

  if (!main || !body) return;

  body.querySelectorAll('[class]').forEach((element) => element.removeAttribute('class'));

  const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => {
    return window.getComputedStyle(heading).display !== 'none' && heading.textContent.trim();
  });

  if (headings.length >= 6) {
    const usedIds = new Set();

    headings.forEach((heading, index) => {
      const base = heading.textContent
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '') || `section-${index + 1}`;
      let id = base;
      let suffix = 2;

      while (usedIds.has(id) || document.getElementById(id)) {
        id = `${base}-${suffix}`;
        suffix += 1;
      }

      usedIds.add(id);
      heading.id = id;
    });

    const nav = document.createElement('nav');
    nav.className = 'myrae-policy-toc';
    nav.setAttribute('aria-label', 'Policy sections');

    const label = document.createElement('p');
    label.className = 'myrae-policy-toc__label';
    label.textContent = 'On this page';

    const list = document.createElement('ul');
    headings.forEach((heading) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      list.appendChild(item);
    });

    nav.append(label, list);
    body.insertBefore(nav, body.firstChild);
  }

  if (main.dataset.policyHandle === 'contact-information') {
    const emailPattern = /inquiries@myrae\.co\.in/;
    const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach((node) => {
      if (!emailPattern.test(node.nodeValue) || node.parentElement.closest('a')) return;

      const parts = node.nodeValue.split(emailPattern);
      const fragment = document.createDocumentFragment();
      parts.forEach((part, index) => {
        if (part) fragment.appendChild(document.createTextNode(part));
        if (index < parts.length - 1) {
          const link = document.createElement('a');
          link.href = 'mailto:inquiries@myrae.co.in';
          link.textContent = 'inquiries@myrae.co.in';
          fragment.appendChild(link);
        }
      });
      node.replaceWith(fragment);
    });
  }
});
